import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import lebianaCatchPageDisplay from "./lebianaCatchPage.styled";
import axios from "axios";
import { setLoginData } from "../../helpers/helpers";
import queryString from "query-string";

const CATCH_LIBYANA_GTM_ID = "GTM-NXSSZ9VC";
const LIBYA_APK_URL =
  "https://mindgamers-apk-842216378405.s3.eu-central-1.amazonaws.com/PlayIt.apk";

function isLibyaHost() {
  return window.location.hostname.includes("libya.playit");
}

function ensureCatchLibyanaGtmOnly() {
  Array.from(document.querySelectorAll("script[src]")).forEach((script) => {
    const src = script.getAttribute("src") || "";
    const isAllowedGtm =
      src.indexOf("googletagmanager.com/gtm.js") !== -1 &&
      src.indexOf(CATCH_LIBYANA_GTM_ID) !== -1;

    if (isAllowedGtm) {
      return;
    }

    if (
      src.indexOf("googletagmanager.com") !== -1 ||
      src.indexOf("google-analytics.com") !== -1 ||
      src.indexOf("connect.facebook.net") !== -1 ||
      src.indexOf("analytics.tiktok.com") !== -1
    ) {
      script.parentNode && script.parentNode.removeChild(script);
    }
  });

  Array.from(document.querySelectorAll("noscript iframe, iframe")).forEach(
    (iframe) => {
      const src = iframe.getAttribute("src") || "";
      if (
        src.indexOf("googletagmanager.com/ns.html") !== -1 &&
        src.indexOf(CATCH_LIBYANA_GTM_ID) === -1
      ) {
        const parent = iframe.parentNode;
        if (parent && parent.tagName === "NOSCRIPT") {
          parent.parentNode && parent.parentNode.removeChild(parent);
        } else {
          parent && parent.removeChild(iframe);
        }
      }
    }
  );

  const alreadyLoaded = Array.from(
    document.querySelectorAll("script[src]")
  ).some(
    (script) =>
      (script.getAttribute("src") || "").indexOf(CATCH_LIBYANA_GTM_ID) !== -1
  );

  if (!alreadyLoaded) {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", CATCH_LIBYANA_GTM_ID);
  }

  const hasNoscript = Array.from(
    document.querySelectorAll("noscript iframe")
  ).some(
    (iframe) =>
      (iframe.getAttribute("src") || "").indexOf(CATCH_LIBYANA_GTM_ID) !== -1
  );

  if (!hasNoscript && document.body) {
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src =
      "https://www.googletagmanager.com/ns.html?id=" + CATCH_LIBYANA_GTM_ID;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }
}

class lebianaCatchPage extends Component {
  async componentDidMount() {
    ensureCatchLibyanaGtmOnly();
    // Give GTM + user time to see success / download button.
    setTimeout(() => {
      this.fireAPI();
    }, isLibyaHost() ? 8000 : 1500);
  }

  fireAPI = async () => {
    const data = queryString.parse(window.location.search);
    if (data.msisdn) {
      await axios
        .get(`https://apissl.playit.mobi/api/v1/getToken/${data.msisdn}/1`)
        .then((res) => {
          setLoginData(
            res.data.user_id,
            res.data.token,
            res.data.user_name,
            res.data.photo,
            res.data.operator_id,
            res.data.user_email,
            res.data.msisdn
          );
          window.location.href = "/";
        })
        .catch(() => {
          window.location.href = "/";
        });
    } else {
      window.location.href = "/";
    }
  };

  render() {
    const showDownload = isLibyaHost();

    return (
      <lebianaCatchPageDisplay className="libya-success-page">
        <div className="libya-success-wrap">
          <h1>
            <Trans>subscription_success</Trans>
          </h1>
          <p>
            <Trans>Thanksubscribing</Trans>
          </p>

          {showDownload ? (
            <a
              className="btn libya-download-btn"
              href={LIBYA_APK_URL}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              Download App
            </a>
          ) : null}

          <p className="libya-redirect-hint">
            <Trans>loading</Trans>...
          </p>
        </div>
      </lebianaCatchPageDisplay>
    );
  }
}
export default withTranslation()(lebianaCatchPage);
